import { FC } from 'react';

import { Responsive } from 'components/_basic/Responsive';

import { DesktopLayout } from './DesktopLayout';
import { MobileLayout } from './MobileLayout';
import { IWorkspaceLayoutProps } from './types';

export const WorkspaceLayout: FC<IWorkspaceLayoutProps> = (props) => {
  return (
    <>
      <Responsive aboveMobile>
        <DesktopLayout {...props} />
      </Responsive>
      <Responsive mobile>
        <MobileLayout {...props} />
      </Responsive>
    </>
  );
};
